export default "__VITE_ASSET__J1iCuQfm__"